import React, { useEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ThemeContext } from '../../contexts'
import { AppState } from '../../types'
import { NavLink } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import DeleteCountryButton from '../../components/DeleteCountryButton'
import { deleteCountry } from '../../redux/actions'
import './style.scss'

const Cart = (props: any) => {
  const countriesBasket = useSelector(
    (state: AppState) => state.countries.inCart
  )
  const { theme } = useContext(ThemeContext)

  const dispatch = useDispatch()
  useEffect(() => {
    if (countriesBasket.length === 0) {
      props.history.push('/')
    }
  })

  return (
    <div
      className="cart__container"
      style={{ backgroundColor: theme.buttonColor }}
    >
      <div className="cart__wrapper animate-appear">
        <div className="cart__exit">
          <NavLink to="/" className="cart__exit-link">
            <IoIosArrowBack style={{ height: '2rem', width: '2rem' }} />
          </NavLink>
        </div>
        <div className="cart__header">
          {countriesBasket.length < 1 ? (
            <h3>No Countries in the basket</h3>
          ) : (
            <h3>
              {countriesBasket.length}{' '}
              {countriesBasket.length > 1 ? 'countries' : 'country'} in your
              basket
            </h3>
          )}
        </div>
        {countriesBasket.map((country: any) => {
          return (
            <ul className="cart__list">
              <li className="cart__flag">
                <img src={country.flags.png} alt={country.name} />
              </li>
              <li>{country.name}</li>
              <li>
                <DeleteCountryButton
                  handleDelete={() => dispatch(deleteCountry(country))}
                />
              </li>
            </ul>
          )
        })}
      </div>
    </div>
  )
}

export default Cart
